
import { Component, Prop } from 'vue-property-decorator';
import ModalView from '@/components/helper/modal-view.vue';
import PageRequest from '@/store/entities/page-request';
import ListBase from '@/lib/listbase';
import Dealer from '@/store/entities/admin/dealer';
import ContactList from './contacts.vue';

class PageDealerConcatRequest extends PageRequest {
    dealer: number = null;
}

@Component({
    components: { ModalView, ContactList },
    watch: {
        value: function (val) {
            let obj = (this as any);
            obj.modalShow = val;
        },
        modalShow: function (val) {
            if (!val) {
                this.$emit('input', false);
            } else {
                (this as any).initForm();
            }
        }
    }
})

export default class DealerForm extends ListBase {
    @Prop({ type: Boolean, default: false }) value: boolean;
    dealer: Dealer = new Dealer();
    pagerequest: PageDealerConcatRequest = new PageDealerConcatRequest();
    modalShow: boolean = false;
    formBase: boolean = true;
    image: any = null;
    modalSetting: any = {
        entity: "dealer",
        title: 'Concesionario',
        width: "1100px",
    };

    items = [
        this.gItem({ type: 'text', prop: 'name', label: 'Nombre', size: 4, required: true }),
        this.gItem({ type: 'text', prop: 'location', label: 'Ciudad', size: 2 }),
        this.gItem({ type: 'text', prop: 'code', label: 'Id', size: 2, required: true }),
        this.gItem({ type: 'text', prop: 'code2', label: 'Codigo', size: 2 }),
        this.gItem({ type: 'text', prop: 'document', label: 'RUC', size: 2 }),
        this.gItem({ type: 'text', prop: 'business_name', label: 'Nombre Completo', size: 6, required: true }),
        this.gItem({ type: 'object', prop: 'zone_id', label: 'Zona', size: 3, required: true }),
        this.gItem({ type: 'object', prop: 'type_id', label: 'Tipo', size: 3, generalType: 'D_TYPES' }),
        this.gItem({ type: 'text', prop: 'address_sales', label: 'Direccion sala de ventas', icon: 'home', size: 6 }),
        this.gItem({ type: 'text', prop: 'address', label: 'Direccion taller de servicio', icon: 'home', size: 6 }),
        this.gItem({ type: 'ubigeo', prop: 'ubigeo', label: '', size: 6, entity: 'department', returnObject: true }),
        this.gItem({ type: 'phone', prop: 'phone1', label: 'Telefono central', size: 2 }),
        this.gItem({ type: 'phone', prop: 'phone2', label: 'Telefono de citas', size: 2 }),
        this.gItem({ type: 'number', prop: 'lat', label: 'Latitud', size: 1 }),
        this.gItem({ type: 'number', prop: 'lng', label: 'Longitud', size: 1 }),
        this.gItem({ type: 'text', prop: 'description', label: 'Notas', size: 6 }),
        this.gItem({ type: 'email', prop: 'email', label: 'Email', size: 4 }),
        this.gItem({ type: 'active', size: 2 }),
    ]
    //photo_facade: string;
    //photo: string;

    get showContacts() {
        return this.$store.state.dealer.editModel.id > 0;
    }

    async getContacts() {
        await this.$store.dispatch({
            type: 'dealercontact/getAll',
            data: { dealer: this.$store.state.dealer.editModel.id }
        });
    }

    async initForm() {
        if (this.$store.state.dealer.editModel.id > 0) {
            this.$store.commit('dealercontact/setDealer', this.$store.state.dealer.editModel.id);
            await this.getContacts();
        }
    }

    async save() {
        this.$emit('save-success');
        this.$emit('input', false);

        this.$store.commit('dealer/setActiveList', []);
        await this.$store.dispatch({
            type: 'dealer/getAllActive',
            data: { force: true }
        });
    }

    cancel() {
        this.$emit('input', false);
    }

    mounted() {
    }

    created() {
    }
}
